export default "__VITE_ASSET__CHdeHE1j__"